const seriesIds = [
  { value: 'PET.EMD_EPD2D_PTE_SCA_DPG.W', name: 'California' },
  { value: 'PET.EMD_EPD2D_PTE_R1Y_DPG.W', name: 'Central Atlantic (PADD 1B)' },
  { value: 'PET.EMD_EPD2D_PTE_R10_DPG.W', name: 'East Coast' },
  { value: 'PET.EMD_EPD2D_PTE_R30_DPG.W', name: 'Gulf Coast' },
  { value: 'PET.EMD_EPD2D_PTE_R1Z_DPG.W', name: 'Lower Atlantic (PADD 1C)' },
  { value: 'PET.EMD_EPD2D_PTE_R20_DPG.W', name: 'Midwest' },
  { value: 'PET.EMD_EPD2D_PTE_R1X_DPG.W', name: 'New England (PADD 1A)' },
  { value: 'PET.EMD_EPD2D_PTE_R40_DPG.W', name: 'Rocky Mountain' },
  { value: 'PET.EMD_EPD2D_PTE_NUS_DPG.W', name: 'U.S.' },
  { value: 'PET.EMD_EPD2D_PTE_R50_DPG.W', name: 'West Coast' },
  {
    value: 'PET.EMD_EPD2D_PTE_R5XCA_DPG.W',
    name: 'West Coast (PADD 5) Except California',
  },
];

export default seriesIds;
